import EditablePropsType from '../../../types/composer';
import themeSchema from './theme';

export const statSchema = {
  type: EditablePropsType.Object,
  label: 'Stat Item',
  name: 'statItem',
  properties: {
    value: {
      type: EditablePropsType.Text,
      name: 'value',
      label: 'Value',
    },
    type: {
      type: EditablePropsType.Select,
      name: 'type',
      label: 'Type',
      selectOptions: {
        options: [
          { value: '', label: '' },
          { value: '%', label: 'Percent' },
          { value: 'x', label: 'Times' },
        ],
      },
    },
    title: {
      type: EditablePropsType.Text,
      name: 'title',
      label: 'Title',
    },
    description: {
      type: EditablePropsType.RichText,
      name: 'description',
      label: 'Description',
    },
    statColor: {
      ...themeSchema,
      name: 'statColor',
      label: 'Stat Color',
    },
  },
};

export const statsSchema = {
  label: 'Stats',
  name: 'stats',
  type: EditablePropsType.Array,
  items: statSchema,
};

export default statsSchema;
